'use strict';

var angular = require('angular');

module.exports = function($scope, $rootScope, $http, $location, ngAudio, ParticipantService) {
    $scope.chain = '';
    $scope.region = '';

    $http.get('/api/game/highscore')
        .then(function(response) {
            $scope.list = response.data.list;
            $scope.ownScore = response.data.participantScore;
            $scope.ownPlace = response.data.participantPlace;
        });

    $http.get('/api/game/get-chains')
        .then(function(response) {
            $scope.chains = response.data;
        });

    $scope.$watch('chain', search);
    $scope.$watch('region', search);

    function search(old, newVal) {
        if (old == newVal && old == '') {
            return;
        }

        var region = $scope.region != ''  && $scope.region !== null ? $scope.region : 'all';
        var chain = $scope.chain != '' && $scope.chain !== null ? $scope.chain.id : 'all';

        $http.get('/api/game/highscore/' + region + '/' + chain)
            .then(function(response) {
                $scope.list = response.data.list;
                $scope.ownScore = response.data.participantScore;
                $scope.ownPlace = response.data.participantPlace;
            });
    }

    $rootScope.replay = function() {
        $rootScope.showReplayPopup = true;
    }

    $rootScope.replaySame = function() {
        $rootScope.showReplayPopup = false;
        $location.path('/game');
    }

    $rootScope.replayNew = function() {
        $rootScope.showReplayPopup = false;

        ParticipantService.clearParticipant()
            .then(function(result) {
                $location.path('/prequiz');
            });
    }
};
